import Section from '../../../elements/Section'
import Container from '../../../elements/Container'
import Grid from '../../../elements/Grid'
import EstateCard from '../../../custom/EstateCard'
import styles from './styles.module.scss'
import Button from '../../../elements/Button'
import IconMore from '/public/icons/icon-more.svg'
import LineSeparator from '../../../elements/LineSeparator'
import Card from '../../../elements/Card'

import Scroll from 'react-scroll'

const Overview = ({
  properties,
  type = 'real-estate',
  shadowRef,
  scrollRef,
  totalCards = 999,
  generalTranslation,
  buttonLabel = 'View more real estate',
  unlimited = false,
  title
}) => {
  const scroll = Scroll.animateScroll

  const handleScroll = () =>
    scrollRef &&
    scroll.scrollTo(
      scrollRef.current?.getBoundingClientRect().top -
        document.body.getBoundingClientRect().top -
        150
    )

  if (properties) {
    return (
      <Section variant={['white', 'pt0', 'center']}>
        <div ref={shadowRef} className={styles.overlay}></div>

        <Container variant={['-xxl']}>
          {title && <h2 className={styles.title}>{title}</h2>}
          <Grid className={styles.grid} variant={[`grid-${totalCards}`]}>
            {properties.map((item, index) => {
              if (index < totalCards || unlimited) {
                if (type === 'real-estate') {
                  return (
                    <EstateCard
                      translations={generalTranslation}
                      key={index}
                      {...item}
                    />
                  )
                } else {
                  return (
                    <Card
                      translations={generalTranslation}
                      key={index}
                      {...item}
                    />
                  )
                }
              }
            })}
          </Grid>

          {buttonLabel && <LineSeparator variant={['vertical']} />}

          {buttonLabel && (
            <Button
              className={styles.button}
              appendIcon={<IconMore />}
              onClick={handleScroll}
              variant={['color-primary']}
            >
              {buttonLabel}
            </Button>
          )}
        </Container>
      </Section>
    )
  }
  return
}

export default Overview
